// Images
import heroImage from './images/hero-image.jpg';
import pecho from './images/pecho.jpg';
import espalda from './images/espalda.jpg';
import hombros from './images/hombros.jpg';
import biceps from './images/biceps.jpg';
import triceps from './images/triceps.jpg';
import piernas from './images/piernas.jpg';
import abdominales from './images/abdominales.jpg';
import logo_gym from './images/logo_gym.png';
import tik_tok from './images/tik_tok.png';
import facebook from './images/facebook.png';
import instagram from './images/instagram.png';
import lugar_energy from './images/aboutSection/lugar_energy.jpg';
import about1 from './images/aboutSection/about1.jpg';
import about2 from './images/aboutSection/about2.jpg';
import about3 from './images/aboutSection/about3.jpg';
import about4 from './images/aboutSection/about4.jpg';
// Nutrition sequence
import nutrition_1 from './images/Nutrition/nutrition_1.png';
import nutrition_2 from './images/Nutrition/nutrition_2.png';
import nutrition_3 from './images/Nutrition/nutrition_3.png';
import nutrition_4 from './images/Nutrition/nutrition_4.png';
import nutrition_5 from './images/Nutrition/nutrition_5.png';
import nutrition_6 from './images/Nutrition/nutrition_6.png';
import nutrition_7 from './images/Nutrition/nutrition_7.png';
import nutrition_8 from './images/Nutrition/nutrition_8.png';
// Section Resultados
import antes1 from './images/SectionResultados/antes1.jpeg';
import despues1 from './images/SectionResultados/despues1.jpeg';
import antes2 from './images/SectionResultados/antes2.jpeg';
import despues2 from './images/SectionResultados/despues2.jpeg';
import antes3 from './images/SectionResultados/antes3.jpeg';
import despues3 from './images/SectionResultados/despues3.jpeg';
// Pecho exercises
import img_press_banca_barra from './images/img_press_banca_barra.jpg';
import img_press_inclinado_barra from './images/img_press_inclinado_barra.jpg';
import img_press_banca_mancuernas from './images/img_press_banca_mancuernas.jpg';
import img_press_inclinado_mancuernas from './images/img_press_inclinado_mancuernas.jpg';
import img_press_maquina from './images/img_press_maquina.jpg';
import img_aperturas_mancuernas from './images/img_aperturas_mancuernas.png';
import img_aperturas_cable from './images/img_aperturas_cable.jpg';
import img_aperturas_pecfly from './images/img_aperturas_pecfly.jpg';
import img_pecho_fondos from './images/img_pecho_fondos.jpg';
// Espalda exercises
import img_e_remo_parado_barra from './images/img_e_remo_parado_barra.jpg';
import img_e_remo_1_mano_mancuerna from './images/img_e_remo_1_mano_mancuerna.jpg';
import img_e_remo_1_mano_polea from './images/img_e_remo_1_mano_polea.jpg';
import img_e_remo_maquina from './images/img_e_remo_maquina.jpg';
import img_e_dominadas from './images/img_e_dominadas.jpg';
import img_e_jalon_agarre_abierto from './images/img_e_jalon_agarre_abierto.jpg';
import img_e_jalon_agarre_cerrado from './images/img_e_jalon_agarre_cerrado.jpg';
import img_e_remo_sentado_polea_abierto from './images/img_e_remo_sentado_polea_abierto.jpg';
import img_e_remo_sentado_polea_cerrado from './images/img_e_remo_sentado_polea_cerrado.jpg';
// Hombros exercises
import img_h_press_militar_barra from './images/img_h_press_militar_barra.jpg';
import img_h_press_militar_mancuernas from './images/img_h_press_militar_mancuernas.jpg';
import img_h_aperturas_laterales from './images/img_h_aperturas_laterales.jpg';
import img_h_elevaciones_frontales from './images/img_h_elevaciones_frontales.jpg';
import img_h_elevaciones_posteriores from './images/img_h_elevaciones_posteriores.jpg';
import img_h_trapecios from './images/img_h_trapecios.jpg';
// Biceps exercises
import img_b_curl_parado_barra from './images/img_b_curl_parado_barra.jpg';
import img_b_curl_banco_scott from './images/img_b_curl_banco_scott.jpg';
import img_b_curl_banco_inclinado from './images/img_b_curl_banco_inclinado.jpg';
import img_b_curl_arana from './images/img_b_curl_arana.jpg';
import img_b_curl_concentrado_1_brazo from './images/img_b_curl_concentrado_1_brazo.jpg';
import img_b_curl_martillo from './images/img_b_curl_martillo.jpg';
// Triceps exercises
import img_t_press_frances from './images/img_t_press_frances.jpg';
import img_t_fondos from './images/img_t_fondos.jpg';
import img_t_empujon_parado_cable from './images/img_t_empujon_parado_cable.jpg';
import img_t_empujon_tras_nuca_cable from './images/img_t_empujon_tras_nuca_cable.jpg';
import img_t_empujon_tras_nuca_mancuernas from './images/img_t_empujon_tras_nuca_mancuernas.jpg';
import img_t_patada from './images/img_t_patada.jpg';
import img_t_extensiones_polea_alta_cruzada from './images/img_t_extensiones_polea_alta_cruzada.jpg';
//Piernas exercises
  //Cuadriceps
import img_c_sentadilla_libre from './images/img_c_sentadilla_libre.jpg';
import img_c_sentadilla_hack from './images/img_c_sentadilla_hack.jpg';
import img_c_sentadilla_multipower from './images/img_c_sentadilla_multipower.jpg';
import img_c_sentadilla_squat_pendulo from './images/img_c_sentadilla_squat_pendulo.jpg';
import img_c_prensa_45_grados from './images/img_c_prensa_45_grados.jpg';
import img_c_extension from './images/img_c_extension.jpg';
import img_c_bulgaras from './images/img_c_bulgaras.jpg';
import img_c_zancadas from './images/img_c_zancadas.jpg';
import img_c_aductores from './images/img_c_aductores.jpg';

// Isquiotibiales  o femorales
import img_f_peso_muerto_rumano from './images/img_f_peso_muerto_rumano.jpg';
import img_f_peso_muerto_b_stand from './images/img_f_peso_muerto_b_stand.jpg';
import img_f_curl_femoral_tumbado from './images/img_f_curl_femoral_tumbado.jpg';
import img_f_curl_femoral_hammer from './images/img_f_curl_femoral_hammer.jpg';
import img_f_curl_femoral_sentado from './images/img_f_curl_femoral_sentado.jpg';
import img_f_curl_nordico from './images/img_f_curl_nordico.jpg';

// Gluteos
import img_g_hip_thrust from './images/img_g_hip_thrust.jpg';
import img_g_puentes from './images/img_g_puentes.jpg';
import img_g_bulgaras from './images/img_g_bulgaras.jpg';
import img_g_peso_muerto_sumo from './images/img_g_peso_muerto_sumo.jpg';
import img_g_sentadilla_sumo from './images/img_g_sentadilla_sumo.jpg';
import img_g_patada_cable from './images/img_g_patada_cable.jpg';
import img_g_patada_maquina from './images/img_g_patada_maquina.jpg';
import img_g_buenos_dias from './images/img_g_buenos_dias.jpg';
import img_g_step_up from './images/img_g_step_up.jpg';
import img_g_abductores from './images/img_g_abductores.jpg';
import img_g_hiperextension from './images/img_g_hiperextension.jpg';


// Abdominales exercises
import img_a_crunch from './images/img_a_crunch.jpg';
import img_a_palo_press_cable from './images/img_a_palo_press_cable.jpg';
import img_a_elevacion_piernas from './images/img_a_elevacion_piernas.jpg';
import img_a_caminata_cangrejo from './images/img_a_caminata_cangrejo.jpg';
import img_a_plancha_frontal from './images/img_a_plancha_frontal.jpg';




// Videos
import heroVideo from './videos/Hero/hero.mp4';
import heroVideoMobile from './videos/Hero/hero_mobile.mp4';
import heroIdleLoop from './videos/Hero/hero_idle_loop.mp4';
import vid_press_banca_barra from './videos/vid_press_banca_barra.mp4';
import vid_press_inclinado_barra from './videos/vid_press_inclinado_barra.mp4';
import vid_pecho_press_banca_mancuerna from './videos/vid_pecho_press_banca_mancuerna.mp4';
import vid_press_inclinado_mancuernas from './videos/vid_press_inclinado_mancuernas.mp4';
import vid_press_maquina from './videos/vid_press_maquina.mp4';
import vid_pecho_aperturas_mancuernas from './videos/vid_pecho_aperturas_mancuernas.mp4';
import vid_aperturas_cable from './videos/vid_aperturas_cable.mp4';
import vid_aperturas_pecfly from './videos/vid_aperturas_pecfly.mp4';
import vid_pecho_fondos from './videos/vid_pecho_fondos.mp4';

//Videos Tiktok - RedSocialSection
import tiktok1 from './videos/tiktok/tiktok1.mp4';
import tiktok2 from './videos/tiktok/tiktok2.mp4';
import tiktok3 from './videos/tiktok/tiktok3.mp4';
import tiktok4 from './videos/tiktok/tiktok4.mp4';

// Nutrition video
import nutrition360 from './images/Nutrition/nutrition360.mp4';


export const images = {
  hero: heroImage,
  // Menus
  pecho,
  espalda,
  hombros,
  biceps,
  triceps,
  piernas, 
  abdominales,
  logo_gym,
  // Redes sociales
  tik_tok,
  facebook,
  instagram,
  lugar_energy,
  about1,
  about2,
  about3,
  about4,
  // Nutrition sequence
  nutrition_1,
  nutrition_2,
  nutrition_3,
  nutrition_4,
  nutrition_5,
  nutrition_6,
  nutrition_7,
  nutrition_8,
  // Section Resultados
  antes1,
  despues1,
  antes2,
  despues2,
  antes3,
  despues3,
  // Ejercicios Pecho
  img_press_banca_barra,
  img_press_inclinado_barra,
  img_press_banca_mancuernas,
  img_press_inclinado_mancuernas,
  img_press_maquina,
  img_aperturas_mancuernas,
  img_aperturas_cable,
  img_aperturas_pecfly,
  img_pecho_fondos,
  // Ejercicios Espalda
  img_e_remo_parado_barra,
  img_e_remo_1_mano_mancuerna,
  img_e_remo_1_mano_polea,
  img_e_remo_maquina,
  img_e_dominadas,
  img_e_jalon_agarre_abierto,
  img_e_jalon_agarre_cerrado,
  img_e_remo_sentado_polea_abierto,
  img_e_remo_sentado_polea_cerrado,
  // Ejercicios Hombros
  img_h_press_militar_barra,
  img_h_press_militar_mancuernas,
  img_h_aperturas_laterales,
  img_h_elevaciones_frontales,
  img_h_elevaciones_posteriores,
  img_h_trapecios,
  // Ejercicios Biceps
  img_b_curl_parado_barra,
  img_b_curl_banco_scott,
  img_b_curl_banco_inclinado,
  img_b_curl_arana,
  img_b_curl_concentrado_1_brazo,
  img_b_curl_martillo,
  // Ejercicios Triceps
  img_t_press_frances,
  img_t_fondos,
  img_t_empujon_parado_cable,
  img_t_empujon_tras_nuca_cable,
  img_t_empujon_tras_nuca_mancuernas,
  img_t_patada,
  img_t_extensiones_polea_alta_cruzada,
  // Ejercicios Piernas
    // Cruadriceps
  img_c_sentadilla_libre,
  img_c_sentadilla_hack,
  img_c_sentadilla_multipower,
  img_c_sentadilla_squat_pendulo,
  img_c_prensa_45_grados,
  img_c_extension,
  img_c_bulgaras,
  img_c_zancadas,
  img_c_aductores,

    // Isquiotibiales o femorales
  img_f_peso_muerto_rumano,
  img_f_peso_muerto_b_stand,
  img_f_curl_femoral_tumbado,
  img_f_curl_femoral_hammer,
  img_f_curl_femoral_sentado,
  img_f_curl_nordico,

    // Gluteos
  img_g_hip_thrust,
  img_g_puentes,
  img_g_bulgaras,
  img_g_peso_muerto_sumo,
  img_g_sentadilla_sumo,
  img_g_patada_cable,
  img_g_patada_maquina,
  img_g_buenos_dias,
  img_g_step_up,
  img_g_abductores,
  img_g_hiperextension,


  // Ejercicios Abdominales
  img_a_crunch,
  img_a_palo_press_cable,
  img_a_elevacion_piernas,
  img_a_caminata_cangrejo,
  img_a_plancha_frontal

};

export const videos = {
  heroVideo,
  heroVideoMobile,
  heroIdleLoop,
  
  vid_press_banca_barra,
  vid_press_inclinado_barra,
  vid_pecho_press_banca_mancuerna,
  vid_press_inclinado_mancuernas,
  vid_press_maquina,
  vid_pecho_aperturas_mancuernas,
  vid_aperturas_cable,
  vid_aperturas_pecfly,
  vid_pecho_fondos,

  //Videos Tiktok - RedSocialSection
  tiktok1,
  tiktok2,
  tiktok3,
  tiktok4,

  // Nutrition video
  nutrition360
};